import React from "react";
import "../css/EscortPassengers.css";

const EscortPassengersList = ({ passengers }) => {
  return (
    <div className="escort-passengers-list">
      <p>Passengers</p>
      {passengers?.length > 0 ? (
        passengers?.map((passenger, index) => (
          <div key={index} className="escort-passenger">
            <p>
              {index + 1}. {passenger.fullName}
            </p>
            <span>Special Onboarding Request</span>
          </div>
        ))
      ) : (
        <p>No passengers require escort service.</p>
      )}
    </div>
  );
};

export default EscortPassengersList;
